__turbopack_context__.v({
  "dark_grey": "Switch-module-scss-module__pCASaa__dark_grey",
  "dark_lightdark-grey": "Switch-module-scss-module__pCASaa__dark_lightdark-grey",
  "dark_switch": "Switch-module-scss-module__pCASaa__dark_switch",
  "switch": "Switch-module-scss-module__pCASaa__switch",
  "transparent": "Switch-module-scss-module__pCASaa__transparent",
  "white": "Switch-module-scss-module__pCASaa__white",
});
